/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

import $ from "jquery";
import DataInconsistencyError from "../exceptions/DataInconsistency";
import EmptyFieldError from "../exceptions/EmptyFieldError";
import {
  getAllCohorts,
  postCohort
} from "../services/cohortService";
import {
  downloadBase64File,
  deleteCohortFromDB,
  downloadContract,
  getContract,
  postTemplate,
  putTemplate
} from "../services/templateService";


/* global document, Office, Word */












Office.onReady((info) => {
  if (info.host === Office.HostType.Word) {
    document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "flex";
    init();
    $(".nav-btn").click(function(){
      switchPage($(this).attr("id"));
    });
    $(".back_to_home").click(backToHome);
    $(".back_to_previous").click(back);
    $(".create").click(createCohort);
    document.getElementById("save_edit").onclick = run;
  }
});


export function switchPage(pageId){
  $(".app_page").hide();
  $("#"+pageId+"_section").show();
}

export function backToHome(){
  switchPage("home");
}

export function back(){
  switchPage("prepare");
}

export function backToCohort(cohort){
  $(".app_page").hide();
  $("#"+cohort+"_modes_section").show();
}

export function change(cohort){
  switchPage(cohort);
}


/**
 * this function initialises the pages at the beginning from all the elements in the database
 */
export async function init() {
  let cohorts = await getAllCohorts();
  for (let i = 0; i < cohorts.length; i++) {
    let cohortCode = cohorts[i].cohort_code;
    let cohortName = cohorts[i].cohort_name;


    addCohortToApp(cohortCode, cohortName);

  }
}


/**
 * this function handles the button remove cohort and it deletes all the related elements in the pages and in the database
 * @param cohortCode the corresponding cohort
 */
export function deleteCohort(cohortCode){

  $(document).on('click','.'+cohortCode+'_remove_input', function(){
    let dialog;
    Office.context.ui.displayDialogAsync(location.origin+"/popup.html", {height: 30, width: 20},
        function (asyncResult) {
          dialog = asyncResult.value;
          dialog.addEventHandler(Office.EventType.DialogMessageReceived, function (arg) {
            let messageFromDialog = arg.message;
            if (messageFromDialog === "Yes"){
              $('#'+cohortCode).remove();
              $('#'+cohortCode+'_icon').remove();

              deleteCohortFromDB(cohortCode);
            }
            else {
              back();
            }
            dialog.close();
          });
        }
    );


  });
}

/**
 * this function gets if the file input is triggered, it takes the new file and update it in the db
 * @param cohortCode
 */
function handleTemplateUpload(cohortCode){
  $('#'+cohortCode+'_SPOC_contract_DE').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'SPOC DE', file, 'PUT');
  });
  $('#'+cohortCode+'_SPOC_contract_DS').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'SPOC DS', file, 'PUT');
  });
  $('#'+cohortCode+'_SPOC_contract_DA').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'SPOC DA', file, 'PUT');
  });


  $('#'+cohortCode+'_SPOC_article14_contract_DE').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'SPOC article14 DE', file, 'PUT');
  });
  $('#'+cohortCode+'_SPOC_article14_contract_DS').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'SPOC article14 DS', file, 'PUT');
  });
  $('#'+cohortCode+'_SPOC_article14_contract_DA').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'SPOC article14 DA', file, 'PUT');
  });


  $('#'+cohortCode+'_Nominal_contract_DE').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'Nominal DE', file, 'PUT');
  });
  $('#'+cohortCode+'_Nominal_contract_DS').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'Nominal DS', file, 'PUT');
  });
  $('#'+cohortCode+'_Nominal_contract_DA').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'Nominal DA', file, 'PUT');
  });



  $('#'+cohortCode+'_Accéléré_contract_DE').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'Accéléré DE', file, 'PUT');
  });
  $('#'+cohortCode+'_Accéléré_contract_DS').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'Accéléré DS', file, 'PUT');
  });
  $('#'+cohortCode+'_Accéléré_contract_DA').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'Accéléré DA', file, 'PUT');
  });


  $('#'+cohortCode+'_pro_contract_DE').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'Contrat Pro DE', file, 'PUT');
  });
  $('#'+cohortCode+'_pro_contract_DS').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'Contrat Pro DS', file, 'PUT');
  });
  $('#'+cohortCode+'_pro_contract_DA').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'Contrat Pro DA', file, 'PUT');
  });


  $('#'+cohortCode+'_apprentice_contract_DE').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'Contrat Apprentissage DE', file, 'PUT');
  });
  $('#'+cohortCode+'_apprentice_contract_DS').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'Contrat Apprentissage DE', file, 'PUT');
  });
  $('#'+cohortCode+'_apprentice_contract_DA').on('change', function(e){
    let file = e.target.files[0];
    uploadTemplate(cohortCode, 'Contrat Apprentissage DE', file, 'PUT');
  });
}

/**
 * this function takes the cohort elements in argument and put the in the pages of the application and it handles buttons.
 */
export function addCohortToApp(cohortCode, cohortName){
                addDynamicHtml(cohortName,cohortCode);




  $(document).on('click','.newCohort_'+cohortCode, function(){
    change(cohortCode+"_modes");
  });

  $(document).on('click','.newCohort_'+cohortCode+'_Nominal', function(){
    change(cohortCode+"_Nominal");
  });
  $(document).on('click','.newCohort_'+cohortCode+'_Accéléré', function(){
    change(cohortCode+"_Accéléré");
  });
  $(document).on('click','.newCohort_'+cohortCode+'_SPOC', function(){
    change(cohortCode+"_SPOC");
  });
  $(document).on('click','.newCohort_'+cohortCode+'_Alternance', function(){
    change(cohortCode+"_Alternance");
  });


  $(document).on('click','.back_to_previous', function(){
    backToCohort(cohortCode);

  });
  $(document).on('click','.back_to_cohort', function(){
    back()


  });
  $(document).on('click','.remove_input', function(){
    deleteCohortFromDB(cohortCode);

  });
  handleTemplateUpload(cohortCode);

  deleteCohort(cohortCode);
  downloadTemplates(cohortCode);
  backToHome();
}


/**
 * this function is triggered when we click on Create cohort button, it posts the new cohort elements in the database, adds the html element and handles the buttons for the new elements
 */
export function createCohort(){

  var newForm = document.getElementById('cohort_form');
  var formData = new FormData(newForm);
  for (var [key, value] of formData) {
    if (value ===""){
      handleError("Empty field, please enter all the elements");
      switchPage("add")
      throw new EmptyFieldError("field empty");
    }
    if (key.includes('contract')){
      if (value.name === ""){
        handleError("Empty field, please enter all the templates");
        switchPage("add")
        throw new EmptyFieldError("field empty");
      }
    }
  }


  var cohortName = $("#cohort_name").val();

  var cohortCode = cohortName[0] + cohortName.slice(-2);
  // we post the elements in db
  postCohort(cohortCode, cohortName);


  // we take the selected files and store them in db (post)
  var spocTemplateDE = document.getElementById("DE_SPOC_contract_input").files[0];
  var spocArticle14TemplateDE = document.getElementById("DE_SPOC_article14_contract_input").files[0];
  var NominalTemplateDE = document.getElementById("DE_Nominal_contract_input").files[0];
  var AccelereTemplateDE = document.getElementById("DE_accelere_contract_input").files[0];
  var contraProTemplateDE = document.getElementById("DE_Pro_contract_input").files[0];
  var contratAppTemplateDE = document.getElementById("DE_Apprenticeship_contract_input").files[0];

  var spocTemplateDS = document.getElementById("DS_SPOC_contract_input").files[0];
  var spocArticle14TemplateDS = document.getElementById("DS_SPOC_article14_contract_input").files[0];
  var NominalTemplateDS = document.getElementById("DS_Nominal_contract_input").files[0];
  var AccelereTemplateDS = document.getElementById("DS_accelere_contract_input").files[0];
  var contraProTemplateDS = document.getElementById("DS_Pro_contract_input").files[0];
  var contratAppTemplateDS = document.getElementById("DS_Apprenticeship_contract_input").files[0];

  var spocTemplateDA = document.getElementById("DA_SPOC_contract_input").files[0];
  var spocArticle14TemplateDA = document.getElementById("DA_SPOC_article14_contract_input").files[0];
  var NominalTemplateDA = document.getElementById("DA_Nominal_contract_input").files[0];
  var AccelereTemplateDA = document.getElementById("DA_accelere_contract_input").files[0];
  var contraProTemplateDA = document.getElementById("DA_Pro_contract_input").files[0];
  var contratAppTemplateDA = document.getElementById("DA_Apprenticeship_contract_input").files[0];


  uploadTemplate(cohortCode, 'SPOC DE', spocTemplateDE, 'POST');
  uploadTemplate(cohortCode, 'SPOC article14 DE', spocArticle14TemplateDE, 'POST');
  uploadTemplate(cohortCode, 'Nominal DE', NominalTemplateDE, 'POST');
  uploadTemplate(cohortCode, 'Accéléré DE', AccelereTemplateDE, 'POST');
  uploadTemplate(cohortCode, 'Contrat Pro DE', contraProTemplateDE, 'POST');
  uploadTemplate(cohortCode, 'Contrat Apprentissage DE', contratAppTemplateDE, 'POST');

  uploadTemplate(cohortCode, 'SPOC DS', spocTemplateDS, 'POST');
  uploadTemplate(cohortCode, 'SPOC article14 DS', spocArticle14TemplateDS, 'POST');
  uploadTemplate(cohortCode, 'Nominal DS', NominalTemplateDS, 'POST');
  uploadTemplate(cohortCode, 'Accéléré DS', AccelereTemplateDS, 'POST');
  uploadTemplate(cohortCode, 'Contrat Pro DS', contraProTemplateDS, 'POST');
  uploadTemplate(cohortCode, 'Contrat Apprentissage DS', contratAppTemplateDS, 'POST');

  uploadTemplate(cohortCode, 'SPOC DA', spocTemplateDA, 'POST');
  uploadTemplate(cohortCode, 'SPOC article14 DA', spocArticle14TemplateDA, 'POST');
  uploadTemplate(cohortCode, 'Nominal DA', NominalTemplateDA, 'POST');
  uploadTemplate(cohortCode, 'Accéléré DA', AccelereTemplateDA, 'POST');
  uploadTemplate(cohortCode, 'Contrat Pro DA', contraProTemplateDA, 'POST');
  uploadTemplate(cohortCode, 'Contrat Apprentissage DA', contratAppTemplateDA, 'POST');

  // this line is for PUT, it updates the previously posted files
  handleTemplateUpload(cohortCode)


  // we add the html elements
  addDynamicHtml(cohortName,cohortCode);


  // we handle the buttons in the new added buttons
  back();
  $(document).on('click','.newCohort_'+cohortCode, function(){
    change(cohortCode+"_modes");

  });

  $(document).on('click','.newCohort_'+cohortCode+'_Nominal', function(){
    change(cohortCode+"_Nominal");
  });
  $(document).on('click','.newCohort_'+cohortCode+'_Accéléré', function(){
    change(cohortCode+"_Accéléré");
  });
  $(document).on('click','.newCohort_'+cohortCode+'_SPOC', function(){
    change(cohortCode+"_SPOC");
  });
  $(document).on('click','.newCohort_'+cohortCode+'_Alternance', function(){
    change(cohortCode+"_Alternance");
  });


  $(document).on('click','.back_to_previous', function(){
    backToCohort(cohortCode);

  });
  $(document).on('click','.back_to_cohort', function(){
    back()


  });

  deleteCohort(cohortCode);
  downloadTemplates(cohortCode);
}

/**
 * This function adds the needed html elements to the application for the new cohorts
 */
function addDynamicHtml(cohortName,cohortCode){
  $('#cohort_selection').append(`<option value="${cohortName}">${cohortName}</option>`);
  $(`#list_cohorts`).append(`<div role="button" id="${cohortCode}" class="ms-welcome__action ms-Button ms-Button--hero ms-font-xl  newCohort_${cohortCode}">
                              <span class="ms-Button-label nav-btn">${cohortName}</span>
                            </div><label class="${cohortCode}_remove_input"><i class="ms-Icon ms-Icon--Delete" title="Remove" aria-hidden="true" id="${cohortCode}_icon" style = "color:#0078d7;"></i></label>`);

  $(`#cohort_modes`).append(`<div id="${cohortCode}_modes_section" class="app_page">

<div role="button" id="${cohortCode}_Nominal" class="ms-welcome__action ms-Button ms-Button--hero ms-font-xl  newCohort_${cohortCode}_Nominal">
                              <span class="ms-Button-label nav-btn">${cohortName} mode Nominal</span>
                            </div>
                            
                            <div role="button" id="${cohortCode}_Accéléré" class="ms-welcome__action ms-Button ms-Button--hero ms-font-xl  newCohort_${cohortCode}_Accéléré">
                              <span class="ms-Button-label nav-btn">${cohortName} mode Accéléré</span>
                            </div>
                            
                            <div role="button" id="${cohortCode}_SPOC" class="ms-welcome__action ms-Button ms-Button--hero ms-font-xl  newCohort_${cohortCode}_SPOC">
                              <span class="ms-Button-label nav-btn">${cohortName} mode SPOC</span>
                            </div>
                            
                            <div role="button" id="${cohortCode}_Alternance" class="ms-welcome__action ms-Button ms-Button--hero ms-font-xl  newCohort_${cohortCode}_Alternance">
                              <span class="ms-Button-label nav-btn">${cohortName} mode alternance</span>
                            </div>
                            
                            <div class="footer_buttons">
                    <button class="btn btn-danger back_to_cohort" >Back</button>
                </div>

</div>`);



  $(`#cohort_pages`).append(`<div id="${cohortCode}_Nominal_section" class="app_page">
    <div id = "${cohortCode}_contracts">
        <h6 class="ms-font-su" style="text-align:center">${cohortName} Nominal contracts:</h6>
        <div class="mb-3">
            <label for="${cohortCode}_Nominal_contract_DE" class="form-label">Upload template for DE</label>
            <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_Nominal_contract_DE">
        </div>
        <button class="btn btn-primary ${cohortCode}_Nominal_download_DE" >Download DE template</button><br>
        
        
        <div class="mb-3">
            <label for="${cohortCode}_Nominal_contract_DS" class="form-label">Upload template for DS</label>
            <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_Nominal_contract_DS">
        </div>
        <button class="btn btn-primary ${cohortCode}_Nominal_download_DS" >Download DS template</button><br>
        
        
        <div class="mb-3">
            <label for="${cohortCode}_Nominal_contract_DA" class="form-label">Upload template for DA</label>
            <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_Nominal_contract_DA">
        </div>
        <button class="btn btn-primary ${cohortCode}_Nominal_download_DA" >Download DA template</button><br>
    </div>

    
    
    <div class="footer_buttons">
        <button class="btn btn-danger back_to_previous" >Back</button>
    </div></div>


    <div id="${cohortCode}_Accéléré_section" class="app_page">
        <div id = "${cohortCode}_contracts">
        <h6 class="ms-font-su" style="text-align:center">${cohortName} contrats Accéléré:</h6>
            
          
            
            <div class="mb-3">
            <label for="${cohortCode}_Accéléré_contract_DE" class="form-label">Upload template for DE</label>
            <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_Accéléré_contract_DE">
        </div>
        <button class="btn btn-primary ${cohortCode}_Accéléré_download_DE" >Download DE template</button><br>
        
        
        <div class="mb-3">
            <label for="${cohortCode}_Accéléré_contract_DS" class="form-label">Upload template for DS</label>
            <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_Accéléré_contract_DS">
        </div>
        <button class="btn btn-primary ${cohortCode}_Accéléré_download_DS" >Download DS template</button><br>
        
        
        <div class="mb-3">
            <label for="${cohortCode}_Accéléré_contract_DA" class="form-label">Upload template for DA</label>
            <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_Accéléré_contract_DA">
        </div>
        <button class="btn btn-primary ${cohortCode}_Accéléré_download_DA" >Download DA template</button><br>
        </div>
    
        
        <div class="footer_buttons">
            <button class="btn btn-danger back_to_previous" >Back</button>
        </div></div>








        <div id="${cohortCode}_SPOC_section" class="app_page">
            <div id = "${cohortCode}_contracts">
            <h6 class="ms-font-su" style="text-align:center">${cohortName} SPOC contracts:</h6>
                <div class="mb-3">
                    <label for="${cohortCode}_SPOC_DE" class="form-label">Upload template for DE</label>
                    <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_SPOC_contract_DE">
                </div>
                <button class="btn btn-primary ${cohortCode}_SPOC_download_DE" >Download DE template</button><br>
                
                <div class="mb-3">
                    <label for="${cohortCode}_SPOC_DS" class="form-label">Upload template for DS</label>
                    <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_SPOC_contract_DS">
                </div>
                <button class="btn btn-primary ${cohortCode}_SPOC_download_DS" >Download DS template</button><br>
                
                <div class="mb-3">
                    <label for="${cohortCode}_SPOC_DA" class="form-label">Upload template for DA</label>
                    <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_SPOC_contract_DA">
                </div>
                <button class="btn btn-primary ${cohortCode}_SPOC_download_DA" >Download DA template</button>
                
                <h6 class="ms-font-su" style="text-align:center">${cohortName} SPOC contracts for article 14 countries:</h6>


                
                <div class="mb-3">
                    <label for="${cohortCode}_SPOC_article14_DE" class="form-label">Upload DE template for article 14 countries</label>
                    <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_SPOC_article14_contract_DE">
                </div>
                <button class="btn btn-primary ${cohortCode}_SPOC_article14_download_DE" >Download DE template</button><br>
                
                <div class="mb-3">
                    <label for="${cohortCode}_SPOC_article14_DS" class="form-label">Upload DS template for article 14 countries</label>
                    <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_SPOC_article14_contract_DS">
                </div>
                <button class="btn btn-primary ${cohortCode}_SPOC_article14_download_DS" >Download DS template</button><br>
                
                <div class="mb-3">
                    <label for="${cohortCode}_SPOC_article14_DA" class="form-label">Upload DA template for article 14 countries</label>
                    <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_SPOC_article14_contract_DA">
                </div>
                <button class="btn btn-primary ${cohortCode}_SPOC_article14_download_DA" >Download DA template</button><br>
                
                
                
            </div>
        
            
            <div class="footer_buttons">
                <button class="btn btn-danger back_to_previous" >Back</button>
            </div></div>


            
        <div id="${cohortCode}_Alternance_section" class="app_page">
            <div id = "${cohortCode}_contracts">
            <h6 class="ms-font-su" style="text-align:center">${cohortName} pro contracts:</h6>
                
                <div class="mb-3">
                    <label for="${cohortCode}_pro_contract_DE" class="form-label">Upload template for DE</label>
                    <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_pro_contract_DE">
                </div>
                <button class="btn btn-primary ${cohortCode}_pro_contract_download_DE" >Download DE template</button><br>
                <div class="mb-3">
                    <label for="${cohortCode}_pro_contract_DS" class="form-label">Upload template for DS</label>
                    <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_pro_contract_DS">
                </div>
                <button class="btn btn-primary ${cohortCode}_pro_contract_download_DS" >Download DS template</button><br>
                <div class="mb-3">
                    <label for="${cohortCode}_pro_contract_DA" class="form-label">Upload template for DA</label>
                    <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_pro_contract_DA">
                </div>
                <button class="btn btn-primary ${cohortCode}_pro_contract_download_DA" >Download DA template</button><br>
                
                <h4 class="ms-font-su" style="text-align:center">${cohortName} apprenticeship contracts:</h4>


                <div class="mb-3">
                    <label for="${cohortCode}_apprentice_contract_DE" class="form-label">Upload template for DE</label>
                    <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_apprentice_contract_DE">
                </div>
                <button class="btn btn-primary ${cohortCode}_apprentice_contract_download_DE" >Download DE template</button><br>
                <div class="mb-3">
                    <label for="${cohortCode}_apprentice_contract_DS" class="form-label">Upload template for DS</label>
                    <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_apprentice_contract_DS">
                </div>
                <button class="btn btn-primary ${cohortCode}_apprentice_contract_download_DS" >Download DS template</button><br>
                <div class="mb-3">
                    <label for="${cohortCode}_apprentice_contract_DA" class="form-label">Upload template for DA</label>
                    <input class="form-control" type="file" accept=".doc, .docx" id="${cohortCode}_apprentice_contract_DA">
                </div>
                <button class="btn btn-primary ${cohortCode}_apprentice_contract_download_DA" >Download DA template</button><br>
            </div>
       
            <div class="footer_buttons">
                <button class="btn btn-danger back_to_previous" >Back</button>
            </div></div>





`);
}


/**
 * this function handles the buttons of downloading the contract from db
 * @param cohortCode
 */
function downloadTemplates(cohortCode){
  $(document).on('click','.'+cohortCode+'_Nominal_download_DE', function(){
    downloadContract(cohortCode,"Nominal DE",cohortCode+'_Nominal_contrat_DE');
  });
  $(document).on('click','.'+cohortCode+'_Nominal_download_DS', function(){
    downloadContract(cohortCode,"Nominal DS",cohortCode+'_Nominal_contrat_DS');
  });
  $(document).on('click','.'+cohortCode+'_Nominal_download_DA', function(){
    downloadContract(cohortCode,"Nominal DA",cohortCode+'_Nominal_contrat_DA');
  });


  $(document).on('click','.'+cohortCode+'_Accéléré_download_DE', function(){
    downloadContract(cohortCode,"Accéléré DE",cohortCode+'_Accéléré_contrat_DE');
  });
  $(document).on('click','.'+cohortCode+'_Accéléré_download_DS', function(){
    downloadContract(cohortCode,"Accéléré DS",cohortCode+'_Accéléré_contrat_DS');
  });
  $(document).on('click','.'+cohortCode+'_Accéléré_download_DA', function(){
    downloadContract(cohortCode,"Accéléré DA",cohortCode+'_Accéléré_contrat_DA');
  });


  $(document).on('click','.'+cohortCode+'_SPOC_download_DE', function(){
    downloadContract(cohortCode,"SPOC DE",cohortCode+'_SPOC_contrat_DE');
  });
  $(document).on('click','.'+cohortCode+'_SPOC_download_DS', function(){
    downloadContract(cohortCode,"SPOC DS",cohortCode+'_SPOC_contrat_DE');
  });
  $(document).on('click','.'+cohortCode+'_SPOC_download_DA', function(){
    downloadContract(cohortCode,"SPOC DA",cohortCode+'_SPOC_contrat_DA');
  });

  $(document).on('click','.'+cohortCode+'_SPOC_article14_download_DE', function(){
    downloadContract(cohortCode,"SPOC article14 DE",cohortCode+'_SPOC_article14_contrat_DE');
  });
  $(document).on('click','.'+cohortCode+'_SPOC_article14_download_DS', function(){
    downloadContract(cohortCode,"SPOC article14 DS",cohortCode+'_SPOC_article14_contrat_DE');
  });
  $(document).on('click','.'+cohortCode+'_SPOC_article14_download_DA', function(){
    downloadContract(cohortCode,"SPOC article14 DA",cohortCode+'_SPOC_article14_contrat_DA');
  });


  $(document).on('click','.'+cohortCode+'_pro_contract_download_DE', function(){
    downloadContract(cohortCode,"Contrat Pro DE",cohortCode+'_pro_contract_contrat_DE');
  });
  $(document).on('click','.'+cohortCode+'_pro_contract_download_DS', function(){
    downloadContract(cohortCode,"Contrat Pro DS",cohortCode+'_pro_contract_contrat_DS');
  });
  $(document).on('click','.'+cohortCode+'_pro_contract_download_DA', function(){
    downloadContract(cohortCode,"Contrat Pro DA",cohortCode+'_pro_contract_contrat_DA');
  });


  $(document).on('click','.'+cohortCode+'_apprentice_contract_download_DE', function(){
    downloadContract(cohortCode,"Contrat Apprentissage DE",cohortCode+'_apprentice_contract_contrat_DE');
  });
  $(document).on('click','.'+cohortCode+'_apprentice_contract_download_DS', function(){
    downloadContract(cohortCode,"Contrat Apprentissage DS",cohortCode+'_apprentice_contract_contrat_DS');
  });
  $(document).on('click','.'+cohortCode+'_apprentice_contract_download_DA', function(){
    downloadContract(cohortCode,"Contrat Apprentissage DA",cohortCode+'_apprentice_contract_contrat_DA');
  });
}


/**
 * this function converts the selected file into a base64 string, and stores it in the db
 * @param cohortCode the corresponding cohort
 * @param contractType the type of the uploaded contract
 * @param file the selected file
 * @param postPut its a string = {POST, PUT} and it indicates whether we are posting the documents or updating in db
 */
function  uploadTemplate(cohortCode, contractType, file, postPut){
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function(){
    var inputData = reader.result;
    var replaceValue = (inputData.split(',')[0]);
    let base64string = inputData.replace(replaceValue + ",", "");
    if (postPut === 'POST'){
      postTemplate(cohortCode, contractType, base64string);
    }
    else {
      putTemplate(cohortCode, contractType, base64string);
    }

  }
}



/**
 * this function return which type of contract based on the campus and the apprenticeship mode
 * @param alternance
 * @param mode
 * @param program
 * @param article14
 * @returns {string}  type
 */
function getContractType(mode, alternance, program, article14){
  let program_code = "";
  if (program === "Applied MSc in Data Science & AI")
    program_code = " DS";
  else if (program === "Applied MSc in Data Engineering for AI")
    program_code = " DE";
  else if (program === "Applied MSc in Data Analytics")
    program_code = " DA";

  if (alternance.includes("Pro"))
    return "Contrat Pro" + program_code;
  else if (alternance.includes("Apprentissage"))
    return "Contrat Apprentissage" + program_code;
  else
    return mode + article14 + program_code;
}

/**
 * this function returns the VAT text used in the contract based on the campus in french and english
 * @param campus
 * @param langue
 * @returns {string[]}
 */
function get_vat_texts(campus){
  if (campus === "Sophia-Antipolis" || campus === "Paris" || campus === "Off-Campus (France)"){
    return ["VAT not applicable","TTC, TVA non applicable"]
  }
  else if (campus === "Off-Campus (Int'l)" || campus === "SPOC (International)"){
    return ["VAT Intracom/export at 0%","TTC, TVA Intracom/Export à 0%"]
  }
  else {
    return ["VAT included at 20%","TTC, inclusif de TVA à 20%"]
  }
}


function handleError(result) {
  let notif=$('.alerts').append(`<div class="alert alert-danger" role="alert">
    ${result}
    </div>`);
  //app.showNotification("Error", "ErrorCode = " + result.code + ", ErrorMessage = " + result.message);
  // eslint-disable-next-line no-undef
  setTimeout(function(){
    notif.remove();
  },4000);
}





/**
 * function to generate the contracts
 */
export async function run() {
  return Word.run(async (context) => {



    // this part will delete any content in the document before we generate the contract (in case we want to regenerate a contract, this will delete the old contract and add the new one
    context.document.body.clear();
    await context.sync();
    const sections = context.document.sections;
    sections.load();
    await context.sync();
    sections.items.forEach(function (section) {
      // Clear the Body
      section.body.clear();

      // Clear any Headers
      section.getHeader("Primary").clear();
      section.getHeader("FirstPage").clear();
      section.getHeader("EvenPages").clear();

      // Clear any Footers
      section.getFooter("Primary").clear();
      section.getFooter("FirstPage").clear();
      section.getFooter("EvenPages").clear();
    });
    await context.sync();





    // we get the useful elements that we will need in the code from the form
    let cohort = $( "#cohort_selection option:selected" ).text();
    let cohort_code = cohort[0] + cohort.slice(-2);
    let mode = $( "#mode option:selected" ).text();
    let alternance = $( "#alternance option:selected" ).text();
    let campus = $( "#campus option:selected" ).text();
    let programme = $( "#programme option:selected" ).text();
    let isChecked=$("#article14").is(":checked");




    // handling input inconsistencies to avoid weird behavior
    if (((mode === "Nominal" || mode === "Accéléré" ) && alternance !== "Non") || (alternance !== "Non" && (campus.includes("SPOC") || campus.includes("International") )) || (alternance ==="Non" && mode === "Apprenticeship") || (mode === "SPOC" && !campus.includes("SPOC")) || (isChecked && mode !== "SPOC")){
      handleError("data inconsistency, please select coherent values");
      throw new DataInconsistencyError("data inconsistency");
    }
    var form = document.getElementById('generate_form');
    var data = new FormData(form);
    for (var [key, value] of data) {
      if ((value === '' && key !== "start_date_SPOC") || (value === '' && mode === "SPOC")){
        handleError("Empty field, please enter all the elements");
        throw new EmptyFieldError("field empty");
      }
    }


    let vatText = get_vat_texts(campus);
    let vatFr = vatText[0];
    let vatEng = vatText[1];

    // variables is the map that will contain all the variables that we will insert in the template.
    // The key of the variables are their names in the template, the values are the inputs from the form and the retrieved data from database
    // we fill the map with all the keys and values
    let variables = new Map();
    variables.set('VAT_TEST_FR', vatFr);
    variables.set('VAT_TEST_EN', vatEng);
    for (const [key, value] of data) {
      variables.set(key, value);
    }

    let article14 = "";
    if(isChecked){
      article14 = " article14";
    }

    // based on the selected cohort, mode and campus, we fetch the corresponding contract from db that we will insert in the document body.
    let contract64 = await getContract(cohort_code, getContractType(mode, alternance, programme, article14));
    await context.sync();
    var body = context.document.body;
    body.insertFileFromBase64(contract64[0][0].document, Word.InsertLocation.start);
    await context.sync();


    // we replace the variables in the template with their values
    for (var [key, value] of variables) {
      let results = context.document.body.search("${CFiller_variable_"+key+"}");
      context.load(results);
      await context.sync().then(function(){
        for (var i = 0; i < results.items.length; i++) {

          results.items[i].insertText(value, "replace");     //Replace the text HERE
        }
      })
          .then(context.sync)
          .catch(function(error){
            handleError(error);
          });
    }




    await context.sync();



  });
}

